module.exports = __webpack_public_path__ + "static/media/white-video.ec2c0d56.webm";